module.exports = __webpack_public_path__ + "img/markerBusGreen.f8292525.svg";